import { create } from "zustand"

import type { ICheckActionRequiredResponse } from "@/types/messenger/ICheckActionRequiredResponse"
import type { IPageResponse } from "@/types/IPageResponse"

type State = {
  instancesList: IPageResponse<ICheckActionRequiredResponse> | null
}

type Actions = {
  setInstances: (newInstances: IPageResponse<ICheckActionRequiredResponse>) => void
  resetInstances: () => void
}

const initialState: State = {
  instancesList: null
}

export const useInstancesStore = create<State & Actions>(set => ({
  instancesList: null,
  setInstances: (newInstances: IPageResponse<ICheckActionRequiredResponse>) =>
    set(() => ({ instancesList: { ...newInstances } })),
  resetInstances: () => set(initialState)
}))
